import { render, staticRenderFns } from "./PriceDrainage.vue?vue&type=template&id=4b7cc78e&scoped=true&"
import script from "./PriceDrainage.vue?vue&type=script&lang=js&"
export * from "./PriceDrainage.vue?vue&type=script&lang=js&"
import style0 from "./PriceDrainage.vue?vue&type=style&index=0&id=4b7cc78e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7cc78e",
  null
  
)

export default component.exports